export enum GameTemplateNames {
  'ct' = 'City Trivia',
  'ctm' = 'Modified City Trivia',
  'tw' = 'Trivial Warfare',
  'default' = 'Default',
}
